<div *ngIf="ras.length > 1" class="custom-table">
  <hr />
  <mat-card appearance="outlined" class="info">
    <p>Escolha com qual <b>Registro Acadêmico</b> deseja acessar:</p>
  </mat-card>
  <table>
    <tr *ngFor="let ra of ras; index as i" (click)="changeSelecao(i)" style="cursor: pointer">
      <td style="display: flex" [ngStyle]="{ border: ra.selecionado ? '2px solid #2196f3' : '0' }">
        <button mat-icon-button color="primary" (click)="changeSelecao(i)">
          <mat-icon>{{ ra.selecionado ? 'task_alt' : 'radio_button_unchecked' }}</mat-icon>
        </button>
        <div class="grid-ra">
          <div class="div-title">Registro Acadêmico:</div>
          <div>{{ ra.numero }}</div>
          <div class="div-title" *ngIf="ra.dataPrimeiraMatricula">Início do Curso:</div>
          <div *ngIf="ra.dataPrimeiraMatricula">{{ ra.dataPrimeiraMatricula | date: 'dd/MM/yyyy' }}</div>
          <div class="div-title" *ngIf="ra.curso">Curso:</div>
          <div *ngIf="ra.curso">{{ ra.curso | nivelPrograma }}</div>
          <div class="div-title" *ngIf="ra.programa">Programa:</div>
          <div *ngIf="ra.programa">{{ ra.programa }}</div>
        </div>
      </td>
    </tr>
  </table>
</div>
